
import { RootState } from '../store';

import { INotification } from './index.interface';

export const selectors = {
  activeNotification: (state: RootState): INotification | null => state.notification.activeNotification,
};
